<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h10"><a id="a18"></a>Prologue</h1>
<p class="p2">Should you have previously read about “the Valentine’s Day incident,” I’d be spared a ton of exposition and exclamation marks and could just cut to the chase.</p>
<p class="p2">Even if you haven’t, you’ve undoubtedly read about a similar “incident”—the quote marks were the media’s, not mine—involving some bigot.</p>
<p class="p2">Everyone had a strong opinion about the “incident.”</p>
<p class="p2">This probably included you. No mea culpa will change that.</p>
<p class="p2">But I’ve gotten ahead of myself, which my husband, Dom, reminds me I’m wont to do, especially when it comes to the night of February 14.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?5173a79c